import React from "react";
//
import {
    Link,
    ListItem,
    ListItemText,
    ListItemIcon,
} from "@material-ui/core";

export default function MenuButton(props) {
    const { handler, icon, name } = props;

    return (
        <Link underline="none" onClick={handler || (() => {})}>
            <ListItem button>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={name} />
            </ListItem>
        </Link>
    );
}
